import axios from '../config/axios';
import { notification } from 'antd';
import {getResponseHandler,header} from './commonService'

const product = {
    getProductList : async (data = {}) => {
        try{
            let rowData;
            rowData = await axios.get('/product',{params:data})
            const response = await rowData;
            return getResponseHandler(response);               
        }catch (error){
            console.error(error);
            notification.error({ message: error.message, placement:'bottomRight' });
        }
    }, 
    getProductById : async (id) => {
        try{
            let rowData;
            rowData = await axios.get('/product/'+id,header())
            const response = await rowData;
            return getResponseHandler(response);               
        }catch (error){
            console.error(error);
            notification.error({ message: error.message, placement:'bottomRight' });
        }
    }, 
    addProduct : async (data={}) =>{
        try{
            const rowData = await axios.post('/product',data)
            const response = await rowData;
            return getResponseHandler(response);               
        }catch (error){
            console.error(error);
            notification.error({ message: error.message, placement:'bottomRight' });
        }
    },
    deleteProduct: async (id={}) => {
        try{
            const rowData = await axios.delete('/product/'+id,header())
            const response = await rowData;
            return getResponseHandler(response);               
        }catch (error){
            console.error(error);
            notification.error({ message: error.message, placement:'bottomRight' });
        }
    }, 
    deleteProductMedia: async (id) => {
        try{
            const rowData = await axios.post('/product/deleteMedia/',id,header())
            const response = await rowData;
            return getResponseHandler(response);               
        }catch (error){
            console.error(error);
            notification.error({ message: error.message, placement:'bottomRight' });
        }
    }, 
    changeStatus : async (data = {}) => {
        try{
            const rowData = await axios.post('/product/statusChange',header(data))
            const response = await rowData;
            return getResponseHandler(response);               
        }catch (error){
            console.error(error);
            notification.error({ message: error.message });
        }
    },
    CheckProduct : async (data = {}) => {
        try{
            const rowData = await axios.post('/product/CheckProduct',header(data))
            const response = await rowData;
            return getResponseHandler(response);               
        }catch (error){
            console.error(error);
            notification.error({ message: error.message });
        }
    },

      
}


export default product
